export const QUESTIONNAIRE_SUBJECT_TYPE = 'questionnaire';
export const SURVEY_SUBJECT_TYPE = 'survey';
export const POLICY_AUDIT_SUBJECT_TYPE = 'policyaudit';
